import { TranslationString } from 'shared/entities/localization';

/** Элемент набора: идентификатор, обычная замена и неподвижная картинка. */
export type CustomEmojiServer = {
  custom_emoji_id: string;
  /** `null` — Telegram не дал замену: элемент недоступен для вставки */
  fallback_emoji: string | null;
  /** `null` — картинку получить не удалось: показывается `fallback_emoji` */
  preview_url: string | null;
};

export type CustomEmojiSetServer = {
  set_name: string;
  title: string;
  /** Когда набор последний раз загружен из Telegram */
  date_updated: string;
  emojis: CustomEmojiServer[];
};

export type CustomEmojiSetsPaginationServer = {
  limit: number;
  offset: number;
  has_more: boolean;
};

/** Почему в проект нельзя добавить набор; `can_add: false` всегда идёт с причиной */
export enum CustomEmojiSetsAddBlockedReason {
  telegramChannelRequired = 'telegram_channel_required',
  emojiSetsLimitReached = 'emoji_sets_limit_reached'
}

/** GET /api/custom_emoji_sets/list */
export type CustomEmojiSetsListServer = {
  items: CustomEmojiSetServer[];
  pagination: CustomEmojiSetsPaginationServer;
  can_add: boolean;
  add_blocked_reason: CustomEmojiSetsAddBlockedReason | null;
};

export type CustomEmojiSetsListParamsServer = {
  limit: number;
  offset: number;
};

/** POST /api/custom_emoji_sets/add */
export type AddCustomEmojiSetParamsServer = {
  url: string;
};

/** POST /api/custom_emoji_sets/refresh, POST /api/custom_emoji_sets/remove */
export type CustomEmojiSetNameParamsServer = {
  set_name: string;
};

/** POST /api/custom_emoji/previews */
export type CustomEmojiPreviewsParamsServer = {
  custom_emoji_ids: string[];
};

export type CustomEmojiPreviewServer = {
  custom_emoji_id: string;
  /** `null` — картинки нет, интерфейс показывает замену из содержимого тега */
  preview_url: string | null;
};

export type CustomEmojiPreviewsServer = {
  items: CustomEmojiPreviewServer[];
};

export enum CustomEmojiSetsListErrorCode {
  listFailed = 'emoji_sets_list_failed'
}

export enum AddCustomEmojiSetErrorCode {
  invalidUrl = 'invalid_emoji_set_url',
  notCustomEmojiSet = 'not_custom_emoji_set',
  setNotFound = 'emoji_set_not_found',
  loadFailed = 'emoji_set_load_failed',
  telegramChannelRequired = 'telegram_channel_required',
  limitReached = 'emoji_sets_limit_reached',
  alreadyAdded = 'emoji_set_already_added'
}

export enum RefreshCustomEmojiSetErrorCode {
  /** Набора нет в проекте: список перечитывается без сообщения об ошибке */
  notAdded = 'not_found',
  telegramChannelRequired = 'telegram_channel_required',
  setNotFound = 'emoji_set_not_found',
  loadFailed = 'emoji_set_load_failed'
}

export enum RemoveCustomEmojiSetErrorCode {
  notAdded = 'not_found'
}

export const mapAddCustomEmojiSetErrorCodeToMessage =
  (code: AddCustomEmojiSetErrorCode): TranslationString =>
  (t) =>
    t(`customEmoji.errors.add.${code}`, {
      ns: 'entities'
    });

export const mapRefreshCustomEmojiSetErrorCodeToMessage =
  (code: RefreshCustomEmojiSetErrorCode): TranslationString =>
  (t) =>
    t(`customEmoji.errors.refresh.${code}`, {
      ns: 'entities'
    });
